import { render } from "./ResourcesPage.vue?vue&type=template&id=f6c24634"
import script from "./ResourcesPage.vue?vue&type=script&lang=js"
export * from "./ResourcesPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__